module.exports = __webpack_public_path__ + "static/media/chair-360.353de573.webp";